/**
 * Created by andrey on 26.12.2020.
 */

const EditorFogs = function () {
    this.alwaysVisible = false;
    this.map2d = Map2d.currentMap;

    this.blocks = {};
    this.fakeUnits = Fogs.ReadDefaults(Map2d.currentMap.field);
    this.loadConfig();
};

EditorFogs.prototype = Object.create(Fogs.prototype);
EditorFogs.prototype.constructor = EditorFogs;

EditorFogs.prototype.loadConfig = Fogs.prototype.loadConfig;

EditorFogs.prototype.isFogRegion = function (code) {
    return Object.keys(this.config).includes(code);
};

EditorFogs.prototype.showBlock = function (code) {
    this.blocks[code] = new EditorFogBlock(code, this);

    const regions = Map2d.currentMap.regions;

    const region = regions[code] || {};
    region.positions = region.positions || [];

    if (region.positions.length) {
        this.addBlockTiles(this.blocks[code], region);
    }
};

EditorFogs.prototype.hideBlock = function (code) {
    const block = this.blocks[code];
    block.tiles.forEach((tile) => {
        tile.open();
        tile.animateOpen();
    });

    if (block.balloonTile) {
        block.balloonTile.open();
        block.balloonTile.animateOpen();
    }

    delete this.blocks[code];
};

EditorFogs.prototype.updateBlock = function (code, oldCode) {
    oldCode = oldCode || code;

    if (this.blocks[oldCode]) {
        this.hideBlock(oldCode);

        if (Map2d.currentMap.regions[code]) {
            this.showBlock(code);
        }
    }
};

EditorFogs.prototype.onAddTile = function (code, x, y) {
    if (code.startsWith("fence_")) {
        Map2dFences.onEdit(x, y, code);
    }

    const block = this.blocks[code];
    if (!block) {
        return;
    }

    const tile = block.findTile(x, y);
    if (tile && tile.fake) {
        block.remove(tile);
    }

    block.add(x, y);

    this.updateHead(code);
    this.updateBalloons(code);
};

EditorFogs.prototype.onRemoveTile = function (code, x, y) {
    if (code.startsWith("fence_")) {
        Map2dFences.onEdit(x, y, code);
    }

    const block = this.blocks[code];
    if (!block) {
        return;
    }

    block.remove(x, y);

    this.updateHead(code);
    this.updateBalloons(code);
};

EditorFogs.prototype.updateHead = function (code) {
    const block = this.blocks[code];
    if (!block) {
        return;
    }

    const oldHead = block.head;
    const newHead = this.getHeadPosition(code);

    if (cc.pointEqualToPoint(oldHead, newHead)) {
        return;
    }

    block.setHead(newHead);
};

EditorFogs.prototype.updateBalloons = function (code) {
    const block = this.blocks[code];
    if (!block) {
        return;
    }

    const oldBalloons = block.balloonTile;
    const newBalloons = this.getBalloonPosition(code);

    if (cc.pointEqualToPoint(oldBalloons, newBalloons)) {
        return;
    }

    if (oldBalloons) {
        block.removeBalloon();
    }

    if (newBalloons) {
        block.addBalloon(newBalloons.x, newBalloons.y);
    }
};

EditorFogs.prototype.getHeadPosition = function (code) {
    const region = Map2d.currentMap.regions[code];
    if (!region || !region.positions.length) {
        return undefined;
    }

    const config = this.config[code];
    if (config && config.headless) {
        return undefined;
    }

    return region.head ? region.head : region.positions[0];
};

EditorFogs.prototype.getBalloonPosition = function (code) {
    const region = Map2d.currentMap.regions[code];
    if (!region || !region.positions.length) {
        return undefined;
    }

    const config = this.config[code];
    if (!config || !config.money) {
        return undefined;
    }

    return region.balloons ? region.balloons : region.positions[0];
};

EditorFogs.prototype.toggleAlwaysVisible = function (visible) {
    if (visible === this.alwaysVisible) {
        return;
    }

    this.alwaysVisible = visible;

    if (this.alwaysVisible) {
        cleverapps.substract(Object.keys(this.config), Object.keys(this.blocks)).forEach(this.showBlock.bind(this));
    } else {
        let toHide = Object.keys(this.config);

        if (this.selected) {
            toHide = cleverapps.substract(toHide, this.getShowCodes(this.selected));
        }

        cleverapps.intersect(Object.keys(this.blocks), toHide).forEach(this.hideBlock.bind(this));
    }

    const map = Map2d.currentMap;
    map.setShowRect(map.showRect, true);
};

EditorFogs.prototype.getShowCodes = function (unit) {
    if (unit.isFog()) {
        return Object.keys(this.config);
    }

    const fencesNames = Map2dFences.getFencesNames();

    if (fencesNames && fencesNames.length > 0) {
        return fencesNames;
    }

    return [unit.code];
};

EditorFogs.prototype.select = function (unit) {
    if (this.selected === unit) {
        return;
    }

    this.selected = unit;

    const codes = this.getShowCodes(unit);
    if (!this.alwaysVisible) {
        cleverapps.substract(Object.keys(this.blocks), codes).forEach(this.hideBlock.bind(this));
    }

    cleverapps.substract(codes, Object.keys(this.blocks)).forEach(this.showBlock.bind(this));

    this.blocks[unit.code].tiles.forEach((tile) => {
        tile.onUpdateState();
    });

    this.scrollTo(this.blocks[unit.code]);

    Map2d.currentMap.getMapView().onFogBlockSelected(this.blocks[unit.code]);
};

EditorFogs.prototype.scrollTo = function (fogBlock) {
    if (!fogBlock.tiles.length) {
        return;
    }
    const targetTile = fogBlock.head || fogBlock.tiles[0];
    Map2d.currentMap.focusOnUnit(targetTile);
};

EditorFogs.prototype.getSelectedCode = function () {
    return this.selected && this.selected.code;
};

EditorFogs.prototype.unselect = function (unit) {
    if (this.selected === unit) {
        delete this.selected;

        let toHide = this.getShowCodes(unit);

        if (this.alwaysVisible) {
            toHide = cleverapps.substract(toHide, Object.keys(this.config));

            if (unit.isFog()) {
                this.blocks[unit.code].tiles.forEach((tile) => {
                    tile.onUpdateState();
                });
            }
        }

        toHide.forEach(this.hideBlock.bind(this));

        Map2d.currentMap.getMapView().onFogBlockUnselected();
    }
};

EditorClient.registerCommand("moveFogBalloon", {
    execute: function (editor, command) {
        const x = command.x;
        const y = command.y;
        const code = command.fogId;

        const region = editor.map.regions[code];
        if (!region) {
            return;
        }

        const prevBalloon = region.balloons;

        if (x !== undefined && y !== undefined) {
            region.balloons = cc.p(x, y);
        } else {
            delete region.balloons;
        }

        editor.map.fogs.updateBalloons(code);
        editor.map.saveLevel();

        cleverapps.effects.fire(x !== undefined && y !== undefined ? "merge.spawn.landing" : "merge.unit.destroy");

        return { type: "moveFogBalloon", data: { x: prevBalloon && prevBalloon.x, y: prevBalloon && prevBalloon.y, fogId: code } };
    }
});

EditorClient.registerCommand("moveFogHead", {
    execute: function (editor, command) {
        const x = command.x;
        const y = command.y;
        const code = command.code;

        const region = editor.map.regions[code];
        if (!region) {
            return;
        }

        const prevHead = region.head;

        if (x !== undefined && y !== undefined) {
            region.head = cc.p(x, y);
        } else {
            delete region.head;
        }

        editor.map.fogs.updateHead(code);
        editor.map.saveLevel();

        cleverapps.effects.fire(x !== undefined && y !== undefined ? "merge.spawn.landing" : "merge.unit.destroy");

        return { type: "moveFogHead", data: { x: prevHead && prevHead.x, y: prevHead && prevHead.y, code: command.code } };
    }
});

EditorClient.registerCommand("moveRegion", {
    execute: function (editor, command) {
        const code = command.code;
        const dx = command.dx;
        const dy = command.dy;

        const region = editor.map.regions[code];
        if (!region) {
            return;
        }

        if (region.head) {
            region.head.x += dx;
            region.head.y += dy;
        }

        if (region.balloons) {
            region.balloons.x += dx;
            region.balloons.y += dy;
        }

        if (region.positions) {
            region.positions.forEach((position) => {
                position.x += dx;
                position.y += dy;
            });
        }

        editor.map.fogs.updateBlock(code);
        editor.map.saveLevel();

        cleverapps.effects.fire("merge.spawn.landing");

        return { type: "moveRegion", data: { code, dx: -dx, dy: -dy } };
    }
});

EditorClient.registerCommand("createRegion", {
    execute: function (editor, command) {
        const code = command.code;
        const positions = command.positions || [];

        editor.map.regions[code] = {
            positions: positions.map((p) => cc.p(p.x, p.y))
        };

        const unit = new RegionUnit({
            code,
            type: RegionUnit.TYPE_REGION
        });
        editor.regions.units.push(unit);
        editor.regions.sort();
        editor.regions.trigger("refresh");

        editor.map.saveLevel();

        cleverapps.effects.fire("merge.spawn.landing");

        return { type: "deleteRegion", data: { code } };
    }
});

EditorClient.registerCommand("deleteRegion", {
    execute: function (editor, command) {
        const code = command.code;
        const region = editor.map.regions[code];
        if (!region) {
            return;
        }

        const positions = region.positions.map((p) => ({ x: p.x, y: p.y }));

        delete editor.map.regions[code];
        editor.map.fogs.hideBlock(code);

        const index = editor.regions.units.findIndex((u) => u.code === code);
        if (index !== -1) {
            editor.regions.units.splice(index, 1);
        }
        editor.regions.trigger("refresh");

        editor.map.saveLevel();

        cleverapps.effects.fire("merge.unit.destroy");

        return { type: "createRegion", data: { code, positions } };
    }
});

EditorClient.registerCommand("renameRegion", {
    execute: function (editor, command) {
        const oldCode = command.oldCode;
        const code = command.code;

        editor.map.regions[code] = editor.map.regions[oldCode];
        delete editor.map.regions[oldCode];

        const unit = editor.regions.units.find((u) => u.code === oldCode);
        if (unit) {
            unit.code = code;
        }
        editor.regions.sort();
        editor.regions.trigger("refresh");

        editor.map.fogs.updateBlock(code, oldCode);

        editor.map.saveLevel();

        cleverapps.effects.fire("merge.spawn.start");

        return { type: "renameRegion", data: { oldCode: code, code: oldCode } };
    }
});

EditorClient.registerCommand("clearRegion", {
    execute: function (editor, command) {
        const code = command.code;
        const regions = editor.map.regions;
        const region = regions[code];
        if (!region) {
            return;
        }

        const positions = region.positions.map((p) => ({ x: p.x, y: p.y }));

        regions[code] = {
            positions: []
        };

        editor.map.fogs.updateBlock(code);
        editor.map.saveLevel();

        cleverapps.effects.fire("merge.unit.destroy");

        return { type: "restoreRegion", data: { code, positions } };
    }
});

EditorClient.registerCommand("restoreRegion", {
    execute: function (editor, command) {
        const code = command.code;
        const positions = command.positions;
        const region = editor.map.regions[code];

        positions.forEach((p) => {
            region.positions.push(cc.p(p.x, p.y));
        });

        editor.map.fogs.updateBlock(code);
        editor.map.saveLevel();

        cleverapps.effects.fire("merge.spawn.landing");

        return { type: "clearRegion", data: { code } };
    }
});

EditorClient.registerCommand("removeFogTile", {
    execute: function (editor, command) {
        const code = command.code;
        const x = command.x;
        const y = command.y;

        const regions = editor.map.regions;

        const region = regions[code];
        if (!region) {
            return { type: "produceFogTile", data: { code, x, y } };
        }

        const index = region.positions.findIndex((cell) => cell.x === x && cell.y === y);
        let head, balloons;
        if (index === -1) {
            return { type: "produceFogTile", data: { code, x, y } };
        }

        region.positions.splice(index, 1);

        if (region.head && region.head.x === x && region.head.y === y) {
            head = true;
            delete region.head;
        }

        if (region.balloons && region.balloons.x === x && region.balloons.y === y) {
            balloons = true;
            delete region.balloons;
        }

        if (region.positions.length === 0) {
            delete regions[code];
        }

        editor.map.fogs.onRemoveTile(code, x, y);
        editor.map.saveLevel();

        cleverapps.effects.fire("merge.unit.destroy");

        return {
            type: "produceFogTile",
            data: {
                code, x, y, index, head, balloons
            }
        };
    }
});

EditorClient.registerCommand("produceFogTile", {
    execute: function (editor, command) {
        const code = command.code;
        const x = command.x;
        const y = command.y;
        const index = command.index;
        const head = command.head;
        const balloons = command.balloons;

        const regions = editor.map.regions;

        if (!regions[code]) {
            regions[code] = {
                positions: []
            };
        }

        const region = regions[code];

        if (head) {
            region.head = cc.p(x, y);
        }

        if (balloons) {
            region.balloons = cc.p(x, y);
        }

        if (!region.positions.some((p) => p.x === x && p.y === y)) {
            region.positions.splice(index === undefined ? region.positions.length : index, 0, cc.p(x, y));
            editor.map.fogs.onAddTile(code, x, y);
        }

        editor.map.saveLevel();

        cleverapps.effects.fire("merge.spawn.landing");

        return { type: "removeFogTile", data: { x, y, code } };
    }
});
